module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-600.woff?7e06644bbdc83069cec8d396149da3ab";